const expirationDays = 30;
const expirationTime = expirationDays * 24 * 60 * 60 * 1000;

// Shipping out of Metrotown -  AB, SK, BC, AB, SK
// Shipping out of Atrium - ON, MB, NB, NS, PE, NL
const metroTownId = 55947133081;
const metroTown = ['AB', 'SK', 'BC', 'AB', 'SK'];
const mujiMetroTown = 'MUJI Metrotown';
const atriumId = 55193239705;
const atrium = ['ON', 'MB', 'NB', 'NS', 'PE', 'NL'];
const mujiAtrium = 'MUJI Atrium';

// Province Selector
function updateProvinceInStorage(province) {
    const expirationDays = 30;
    const expirationTime = expirationDays * 24 * 60 * 60 * 1000;
    const now = new Date().getTime();
    const item = {
        value: province,
        expiry: now + expirationTime,
    };
    localStorage.setItem("canadianProvince", JSON.stringify(item));
}

// Function to add event listeners to all elements with the class .province-selector
function setupProvinceSelectors() {
    const provinceSelectors = document.querySelectorAll(".province-selector");

    provinceSelectors.forEach(selector => {
        selector.addEventListener("change", (event) => {
            const selectedProvince = event.target.value;
            updateProvinceInStorage(selectedProvince);
        });
    });
}

// PDP display availability
function getProvinceWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    const now = new Date().getTime();

    // Check if the item has expired
    if (now > item.expiry) {
        localStorage.removeItem(key); // Remove expired item
        return null;
    }
    return item.value;
}

function updateProvinceSelection(currentProvince) {
    const locationDropDown = document.querySelectorAll('.location-dropdown');
    locationDropDown.forEach(ldd => {
        const provinceSelector = ldd.querySelector('.province-selector');
        
        if(!ldd) return;

        const locationOptions = ldd.querySelectorAll('option');
        let findCurrentSelectIndex = 0;
        locationOptions.forEach((location, locInd) => {
            location.selected = currentProvince !== location.value;
            if(currentProvince === location.value) findCurrentSelectIndex = locInd
        });

        provinceSelector.selectedIndex = findCurrentSelectIndex;
    })

}

function shippingLocation(currentProvince){
    let currentShippingLocation;

    if(atrium.includes(currentProvince)){
        currentShippingLocation = {
            location: mujiAtrium,
            id: atriumId,
        }
    } else if(metroTown.includes(currentProvince)){
        currentShippingLocation = {
            location: mujiMetroTown,
            id: metroTownId,
        }
    } 

    return currentShippingLocation;
}

function getStockBasedOnLocationId(inventoryInfoData, locationId){
    let findInventoryLocationIndex;
    let currentStoreStock = 0;

    findInventoryLocationIndex = inventoryInfoData.inventoryInfo.findIndex(iid => iid.location.id === locationId);

    if(findInventoryLocationIndex !== -1){
        currentStoreStock = inventoryInfoData.inventoryInfo[findInventoryLocationIndex].quantity;
    }

    return currentStoreStock;
}

function displayAvailabiltyByLocation(currentProvince){
    const inventoryInfoApp = document.getElementById('location-inventory-info');
    if(!inventoryInfoApp) return;

    let currentShippingLocation = shippingLocation(currentProvince)
    
    if(!currentShippingLocation) return;

    const locationContainers = document.querySelectorAll('.lli-list-item');
    if(locationContainers){
        locationContainers.forEach(location => {
            const locationContent = location.dataset.locationName.toLocaleLowerCase();
            if(locationContent.includes(currentShippingLocation.location.toLocaleLowerCase())){
                location.classList.remove('hide-lli');
            }
        })
    }
}

function setCollectionLocationFilter(currentSelectedProvince){
    const url = new URL(window.location.href);
    const queryParams = new URLSearchParams(url.search);
    let currentShippingLocation = shippingLocation(currentSelectedProvince)

    // Delete all instances of the parameter "filter.v.m.locationInventory.locations"
    queryParams.delete("filter.v.m.locationInventory.locations");
    queryParams.append("filter.v.m.locationInventory.locations", currentShippingLocation.location);

    url.search = queryParams.toString();
    window.history.replaceState(null, '', url.toString())
}

function updatePDP(currentSelectedProvince){
    const inventoryInfoApp = document.getElementById('inventory_info_metafield_data');
    const currentShippingLocation = shippingLocation(currentSelectedProvince);

    if(!inventoryInfoApp) return;

    let inventoryInfoData = JSON.parse(inventoryInfoApp.dataset.inventoryInfoMetafieldData);
    let inventoryInfoTranslations = JSON.parse(inventoryInfoApp.dataset.inventoryInfoTranslations);

    if(!inventoryInfoData) return;

    inventoryInfoData = inventoryInfoData.map(variantMetafield => {
        let tempVariantMetafield = variantMetafield;
        tempVariantMetafield.inventoryInfo = JSON.parse(tempVariantMetafield.inventoryInfo.replace(/&quoteFormat;/g, '"'));

        return tempVariantMetafield;
    })[0] || null;

    updateATCButton(currentShippingLocation, inventoryInfoData, inventoryInfoTranslations);
}

function updateATCButton(currentShippingLocation, inventoryInfoData, inventoryInfoTranslations){
    const productATC = document.querySelector('.product-form--atc-button');

    if(!productATC) return;

    let storeStock = getStockBasedOnLocationId(inventoryInfoData, currentShippingLocation.id);
    if(storeStock > 0) {
        productATC.textContent = inventoryInfoTranslations.atc.add_to_cart
    } else {
        productATC.textContent = inventoryInfoTranslations.atc.sold_out
        if (!productATC.classList.contains('disabled')) {
            productATC.classList.add('disabled');
        }
    
        if (!productATC.hasAttribute('disabled')) {
        productATC.setAttribute('disabled', '');
        }
    }
}

function debounce(func, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
}

document.addEventListener('DOMContentLoaded', (event) => {
    const locationDropDown = document.querySelectorAll('.location-dropdown .province-selector');
    const pageType = document.querySelector('[data-page-type');
    let currentSelectedProvince = getProvinceWithExpiry('canadianProvince');

    setupProvinceSelectors();
    displayAvailabiltyByLocation(currentSelectedProvince);
    updatePDP(currentSelectedProvince);
    updateProvinceSelection(currentSelectedProvince);
    
    if(!locationDropDown) return;

    if(pageType.dataset.pageType === 'collection'){
        setCollectionLocationFilter(currentSelectedProvince);
    }

    locationDropDown.forEach(ldd => {
        ldd.addEventListener('change', debounce((event) => {
            if (pageType.dataset.pageType === 'collection') {
                currentSelectedProvince = getProvinceWithExpiry('canadianProvince');
                setCollectionLocationFilter(currentSelectedProvince);
            }

            location.reload();
        }, 1200));
    });
});
